import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IDashboardSummary } from "../../models"

interface IDashboardSummaryState {
    clientesAtivos: number
    usuariosAtivos: number
    consumoTotalMensal: number
    consumoTotalHoje: number
    consumoIATotalHoje: number
    consumoIDTotalHoje: number
    consumoAPITotalHoje: number
    consumoGeoTOTALHoje: number
    consumoAutoTOTALHoje: number
    consumoScrapyTOTALHoje: number
    consumoIATotalMensal: number
    consumoIDTotalMensal: number
    consumoAPITotalMensal: number
    consumoGeoTOTALMensal: number
    consumoAutoTOTALMensal: number
    consumoScrapyTOTALMensal: number
    // Top Consumo Arrays (Diário)
    topClientesDaily: IDashboardSummary[]
    topUsuariosDaily: IDashboardSummary[]
    topProdutosDaily: IDashboardSummary[]
    topVariaveisDaily: IDashboardSummary[]
    // Top Consumo Arrays (Mensal/Total)
    topClientesTotal: IDashboardSummary[]
    topUsuariosTotal: IDashboardSummary[]
    topProdutosTotal: IDashboardSummary[]
    topVariaveisTotal: IDashboardSummary[]
    consultaPorTipoConsumo_1: IDashboardSummary
    consultaPorTipoConsumo_2: IDashboardSummary
    consultaPorTipoConsumo_3: IDashboardSummary
    consultaPorTipoConsumo_4: IDashboardSummary
    consultaPorTipoConsumo_5: IDashboardSummary
    consultaPorTipoConsumo_6: IDashboardSummary
    consultaPorTipoConsumo_7: IDashboardSummary
    consultaPorTipoConsumo_8: IDashboardSummary
    consultaPorTipoConsumo_9: IDashboardSummary
    consultaPorTipoConsumo_Outros: IDashboardSummary
    consultaPorUsuario_1: IDashboardSummary
    consultaPorUsuario_2: IDashboardSummary
    consultaPorUsuario_3: IDashboardSummary
    consultaPorUsuario_4: IDashboardSummary
    consultaPorUsuario_5: IDashboardSummary
    consultaPorUsuario_6: IDashboardSummary
    consultaPorUsuario_7: IDashboardSummary
    consultaPorUsuario_8: IDashboardSummary
    consultaPorUsuario_9: IDashboardSummary
    consultaPorUsuario_Outros: IDashboardSummary
}

const initialState: IDashboardSummaryState = {
    clientesAtivos: 0,
    usuariosAtivos: 0,
    consumoTotalMensal: 0,
    consumoTotalHoje: 0,
    consumoIATotalHoje: 0,
    consumoIDTotalHoje: 0,
    consumoAPITotalHoje: 0,
    consumoGeoTOTALHoje: 0,
    consumoAutoTOTALHoje: 0,
    consumoScrapyTOTALHoje: 0,
    consumoIATotalMensal: 0,
    consumoIDTotalMensal: 0,
    consumoAPITotalMensal: 0,
    consumoGeoTOTALMensal: 0,
    consumoAutoTOTALMensal: 0,
    consumoScrapyTOTALMensal: 0,
    topClientesDaily: [],
    topUsuariosDaily: [],
    topProdutosDaily: [],
    topVariaveisDaily: [],
    topClientesTotal: [],
    topUsuariosTotal: [],
    topProdutosTotal: [],
    topVariaveisTotal: [],
    consultaPorTipoConsumo_1: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_2: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_3: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_4: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_5: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_6: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_7: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_8: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_9: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorTipoConsumo_Outros: { Nome: '', Quantidade: 0, Cliente: '', Produto: '' },
    consultaPorUsuario_1: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_2: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_3: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_4: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_5: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_6: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_7: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_8: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_9: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    },
    consultaPorUsuario_Outros: {
        Nome: '',
        Quantidade: 0,
        Cliente: '',
        Produto: ''
    }
}

const dashboardSummarySlice = createSlice({
    name: 'DashboardSummary',
    initialState,
    reducers: {
        setDashboardSummaryState(state, action: PayloadAction<{
            clientesAtivos: number
            usuariosAtivos: number
            consumoTotalMensal: number
            consumoTotalHoje: number
            consumoIATotalHoje: number
            consumoIDTotalHoje: number
            consumoAPITotalHoje: number
            consumoGeoTOTALHoje: number
            consumoAutoTOTALHoje: number
            consumoScrapyTOTALHoje: number
            consumoIATotalMensal: number
            consumoIDTotalMensal: number
            consumoAPITotalMensal: number
            consumoGeoTOTALMensal: number
            consumoAutoTOTALMensal: number
            consumoScrapyTOTALMensal: number
            topClientesDaily: IDashboardSummary[]
            topUsuariosDaily: IDashboardSummary[]
            topProdutosDaily: IDashboardSummary[]
            topVariaveisDaily: IDashboardSummary[]
            topClientesTotal: IDashboardSummary[]
            topUsuariosTotal: IDashboardSummary[]
            topProdutosTotal: IDashboardSummary[]
            topVariaveisTotal: IDashboardSummary[]
            consultaPorTipoConsumo_1: IDashboardSummary
            consultaPorTipoConsumo_2: IDashboardSummary
            consultaPorTipoConsumo_3: IDashboardSummary
            consultaPorTipoConsumo_4: IDashboardSummary
            consultaPorTipoConsumo_5: IDashboardSummary
            consultaPorTipoConsumo_6: IDashboardSummary
            consultaPorTipoConsumo_7: IDashboardSummary
            consultaPorTipoConsumo_8: IDashboardSummary
            consultaPorTipoConsumo_9: IDashboardSummary
            consultaPorTipoConsumo_Outros: IDashboardSummary
            consultaPorUsuario_1: IDashboardSummary
            consultaPorUsuario_2: IDashboardSummary
            consultaPorUsuario_3: IDashboardSummary
            consultaPorUsuario_4: IDashboardSummary
            consultaPorUsuario_5: IDashboardSummary
            consultaPorUsuario_6: IDashboardSummary
            consultaPorUsuario_7: IDashboardSummary
            consultaPorUsuario_8: IDashboardSummary
            consultaPorUsuario_9: IDashboardSummary
            consultaPorUsuario_Outros: IDashboardSummary
        }>) {
            state.clientesAtivos = action.payload.clientesAtivos
            state.consumoIATotalHoje = action.payload.consumoIATotalHoje
            state.consumoIDTotalHoje = action.payload.consumoIDTotalHoje
            state.consumoTotalHoje = action.payload.consumoTotalHoje
            state.consumoTotalMensal = action.payload.consumoTotalMensal
            state.consumoAPITotalHoje = action.payload.consumoAPITotalHoje
            state.consumoGeoTOTALHoje = action.payload.consumoGeoTOTALHoje
            state.consumoAutoTOTALHoje = action.payload.consumoAutoTOTALHoje
            state.consumoScrapyTOTALHoje = action.payload.consumoScrapyTOTALHoje
            state.consumoIATotalMensal = action.payload.consumoIATotalMensal
            state.consumoIDTotalMensal = action.payload.consumoIDTotalMensal
            state.consumoAPITotalMensal = action.payload.consumoAPITotalMensal
            state.consumoGeoTOTALMensal = action.payload.consumoGeoTOTALMensal
            state.consumoAutoTOTALMensal = action.payload.consumoAutoTOTALMensal
            state.consumoScrapyTOTALMensal = action.payload.consumoScrapyTOTALMensal
            state.usuariosAtivos = action.payload.usuariosAtivos
            state.topClientesDaily = action.payload.topClientesDaily
            state.topUsuariosDaily = action.payload.topUsuariosDaily
            state.topProdutosDaily = action.payload.topProdutosDaily
            state.topVariaveisDaily = action.payload.topVariaveisDaily
            state.topClientesTotal = action.payload.topClientesTotal
            state.topUsuariosTotal = action.payload.topUsuariosTotal
            state.topProdutosTotal = action.payload.topProdutosTotal
            state.topVariaveisTotal = action.payload.topVariaveisTotal
            state.consultaPorTipoConsumo_1 = action.payload.consultaPorTipoConsumo_1
            state.consultaPorTipoConsumo_2 = action.payload.consultaPorTipoConsumo_2
            state.consultaPorTipoConsumo_3 = action.payload.consultaPorTipoConsumo_3
            state.consultaPorTipoConsumo_4 = action.payload.consultaPorTipoConsumo_4
            state.consultaPorTipoConsumo_5 = action.payload.consultaPorTipoConsumo_5
            state.consultaPorTipoConsumo_6 = action.payload.consultaPorTipoConsumo_6
            state.consultaPorTipoConsumo_7 = action.payload.consultaPorTipoConsumo_7
            state.consultaPorTipoConsumo_8 = action.payload.consultaPorTipoConsumo_8
            state.consultaPorTipoConsumo_9 = action.payload.consultaPorTipoConsumo_9
            state.consultaPorTipoConsumo_Outros = action.payload.consultaPorTipoConsumo_Outros
            state.consultaPorUsuario_1 = action.payload.consultaPorUsuario_1
            state.consultaPorUsuario_2 = action.payload.consultaPorUsuario_2
            state.consultaPorUsuario_3 = action.payload.consultaPorUsuario_3
            state.consultaPorUsuario_4 = action.payload.consultaPorUsuario_4
            state.consultaPorUsuario_5 = action.payload.consultaPorUsuario_5
            state.consultaPorUsuario_6 = action.payload.consultaPorUsuario_6
            state.consultaPorUsuario_7 = action.payload.consultaPorUsuario_7
            state.consultaPorUsuario_8 = action.payload.consultaPorUsuario_8
            state.consultaPorUsuario_9 = action.payload.consultaPorUsuario_9
            state.consultaPorUsuario_Outros = action.payload.consultaPorUsuario_Outros
        }
    }
})

export const { setDashboardSummaryState } = dashboardSummarySlice.actions

export const dashboardSummaryReducer = dashboardSummarySlice.reducer